import { Impersonate } from '@/components/dev/Impersonate'
import { ReactQueryDevToolsProduction } from '@/components/dev/ReactQueryDevTools'
import { useUserContext } from '@/index'

export interface DevToolsProps {}

export const DevTools: React.FC<DevToolsProps> = ({}) => {
  const { isDeveloper } = useUserContext()
  return (
    <>
      {isDeveloper(true) && <Impersonate />}
      {isDeveloper() && <ReactQueryDevToolsProduction />}
    </>
  )
}
